(function () {
  const replacements = {
    'Flavors': 'Flavours',
    'Flavor': 'Flavour',
    'Stabilizers': 'Stabilisers',
    'Stabilizer': 'Stabiliser',
    'Customized': 'Customised',
    'Customize': 'Customise',
    'Palletized': 'Palletised',
    'Colors': 'Colours',
    'Color': 'Colour',
    'Fiber': 'Fibre',
    'Center': 'Centre',
    'Labor': 'Labour',
    'Optimize': 'Optimise',
    'Organized': 'Organised',
    'Specialize': 'Specialise'
  };

  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      let text = node.nodeValue;

      Object.keys(replacements).forEach(function (word) {
        const regex = new RegExp('\\b' + word + '\\b', 'g');
        text = text.replace(regex, replacements[word]);
      });

      node.nodeValue = text;
      return;
    }

    if (
      node.nodeType !== Node.ELEMENT_NODE ||
      ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT'].includes(node.tagName)
    ) {
      return;
    }

    node.childNodes.forEach(replaceText);
  }

  function runReplacement() {
    replaceText(document.body);
  }

  if (document.body) {
    runReplacement();
  } else {
    document.addEventListener('DOMContentLoaded', runReplacement);
  }

  // Shopify/AJAX/dynamic content ke liye
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        replaceText(node);
      });
    });
  });

  function startObserver() {
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startObserver);
  }
})();